import { render, staticRenderFns } from "./comTerm0.vue?vue&type=template&id=4a23134e&scoped=true&"
import script from "./comTerm0.vue?vue&type=script&lang=js&"
export * from "./comTerm0.vue?vue&type=script&lang=js&"
import style0 from "./comTerm0.vue?vue&type=style&index=0&id=4a23134e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23134e",
  null
  
)

export default component.exports